import { useQuery } from '@tanstack/react-query'

import { fetchOperationVerificationPrefill } from '@/lib/venue/operationVerificationApi'

/** EP-3 — 재신청 prefill 조회(`#772`). 신청 이력이 없어도 200이라 `isError` 는 진짜 조회 실패만 뜻한다. */
export function useOperationVerificationPrefill(venueId: string) {
  return useQuery({
    queryKey: ['venue', venueId, 'operation-verification', 'prefill'] as const,
    queryFn: () => fetchOperationVerificationPrefill(venueId),
  })
}
